<template>
  <cs-dialog v-model="isShownDialog">
    <dialog-default-layout>
      <div slot="title" class="confirmation-title">
        <h2>{{ $t('request.additional.data.from.viewers') }}</h2>
      </div>
      <div slot="content" class="confirmation-message">
        <p>{{ $t('for.correctly.work.widget.we.will.add.fields') }}</p>
        <ul class="confirmation-feild-list">
          <li v-for="field in senderFields" :key="field.name" class="confirmation-feild-item">
            {{ $t(field.value) }}
          </li>
        </ul>
        <p v-html="$t('can.disable.fields.after.stream', { getSettingsPaymentLink })"></p>
      </div>
      <div slot="footer" class="confirmation-control-buttons">
        <div class="confirmation-control-active">
          <cs-button width="100%" @click="onConfirmation">
            {{ $t('turn.on') }}
          </cs-button>
        </div>
        <div class="confirmation-control-cancel">
          <cs-button width="100%" type="transparent" @click="onClose">
            {{ $t('common.cancel') }}
          </cs-button>
        </div>
      </div>
    </dialog-default-layout>
  </cs-dialog>
</template>

<script>
import DialogDefaultLayout from 'modules/Dialogs/DefaultLayout';

export default {
  name: 'WidgetSaveConfirmation',
  components: {
    DialogDefaultLayout,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    senderFields: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isShownDialog: false,
    };
  },
  computed: {
    getSettingsPaymentLink() {
      return 'https://my.capusta.space/settings/payment';
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.isShownDialog = val;
      },
    },
    isShownDialog: {
      handler(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    onConfirmation() {
      this.$emit('confirmation');

      this.$nextTick(() => {
        this.isShownDialog = false;
      });
    },
    onClose() {
      this.isShownDialog = false;
    },
  },
};
</script>

<style lang="sass" scoped>
  .confirmation-title
    width: 200px

    +respond-to('small')
      width: 350px

    &:after
      content: ''
      width: 90px
      height: 155px
      position: absolute
      top: 30px
      right: 0
      background-image: url('~@/assets/svg/widgets/widget-cat.svg')
      background-repeat: no-repeat
      background-position: center

  .confirmation-message
    width: 100%
    font-weight: 500
    font-size: 14px
    line-height: 20px
    color: #fff
    opacity: .75

    +respond-to('small')
      width: 350px

    a
      color: #7CB342

  .confirmation-feild-list
    margin-bottom: 30px
    padding-left: 16px
    list-style: disc

  .confirmation-feild-item
    font-weight: 700

  .confirmation-control-buttons
    display: flex
    flex-direction: column

    +respond-to('small')
      flex-direction: row
      justify-content: space-between

  .confirmation-control-active
    width: 100%
    margin-bottom: 10px

    +respond-to('small')
      width: 230px
      margin-bottom: 0
</style>
